module.exports = __webpack_public_path__ + "img/box.5afbaaff.svg";